// extracted by mini-css-extract-plugin
export const content = "layout-module--content--3GWBe";
export const footer = "layout-module--footer--3iD_9";
export const subscribeInfo = "layout-module--subscribeInfo--3iq_P";
export const footerLinks = "layout-module--footerLinks--3IizX";
export const footerBranding = "layout-module--footerBranding--2YNuN";
export const footerLinkList = "layout-module--footerLinkList--2RpCX";
export const isActive = "layout-module--isActive--1Gpr3";